import { createFileRoute } from '@tanstack/react-router'
import { GuaranteesPage } from '../../features/guarantees'
import { GuaranteesAccessGuard } from './-guaranteesAccess'

export const Route = createFileRoute('/_authenticated/guarantees')({
  component: GuaranteesRoute,
})

function GuaranteesRoute() {
  return (
    <GuaranteesAccessGuard>
      <GuaranteesPage />
    </GuaranteesAccessGuard>
  )
}
